import * as React from "react"
import { Link } from "react-router-dom"
import { isDigitsMacApp } from "@digits-shared/helpers/devicesHelper"
import colors from "@digits-shared/themes/colors"
import fonts, { BodyText } from "@digits-shared/themes/typography"
import styled from "styled-components"
import routes from "src/frontend/routes"

const StyledLink = styled(Link)`
  font-weight: ${fonts.weight.heavy};
  transition: color 175ms;
  &:hover {
    color: ${colors.logoGreen};
  }
`

export const SignUpLink: React.FC = () =>
  // connectors do not work in mac app, so disable for now
  !isDigitsMacApp && (
    <BodyText>
      Need an account?{" "}
      <StyledLink to={routes.plgOnboardingRoot.parameterizedPath}>Sign Up</StyledLink>
    </BodyText>
  )

export const SignInLink: React.FC<{ className?: string }> = ({ className }) => (
  <BodyText className={className}>
    Already have an account? <StyledLink to={routes.login.parameterizedPath}>Sign In</StyledLink>
  </BodyText>
)
